<template>
  <div class="orders__list orders__list--single">
    <div class="gd-search__forms-wrap ">
      <div class="gd-searh__input-wrap">
        <input
          class="gd-searh__input"
          v-model="search"
          placeholder="Search"
          name="kw"
          type="text"
          aria-label="Input search"
        />
        <div class="gd-searh__btn">
          <svg>
            <use xlink:href="#icon-search-light"></use>
          </svg>
        </div>
      </div>
    </div>
    <div class="order__product">
      <TransitionGroup name="list" tag="div">
        <OrderComponent v-for="(order, index) in filterdOrder" :key="order.id + index" :order="order" />
      </TransitionGroup>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { Order } from "./order";
import OrderComponent from "./OrderComponent.vue";
import {type Ref, ref, computed, type ComputedRef } from 'vue'

const orders = (window as any).orders as Order[];

const search: Ref<string> = ref('')

const filterdOrder:  ComputedRef<Order[]> = computed(()=>{
  const string = search.value.trim().toLowerCase()
  if(!string) return orders
  return orders.filter(item=>{
    return item.sku.toLowerCase().includes(string) || item.name.toLowerCase().includes(string)
  })
})

</script>
